<template>
  <!--

  This functionality is not needed anymore

  -->
  <Modal @close="closeModalLocal" :wide="false" width="427px" :showClose="false">
    <Loading :show="loading" />

    <div :class="{disabled: loading, center: true}">
      <h1>Din reservation har gått ut</h1>

      <p>Din reservation i varukorgen har gått ut. Andra gäster kan boka det som var reserverat av dig.</p>

      <table>
        <thead>
        </thead>
        <tbody>
          <tr v-for="(accomodation, index) in accomodations">
            <td>
              <b>{{accomodation.name}}</b>
              <br>
              {{ [accomodation.period.date_arrival, accomodation.period.date_departure] | dateRange('D MMMM', ' - ') }}
            </td>
            <td style="text-align:right;">
              <b>{{(accomodation.quantity * accomodation.price) | currency}}</b>
            </td>
            <td v-if="!accomodation.reclaimed" style="text-align:right;">
              <button class="small" @click="reclaim('accomodation', accomodation, index)">Reservera</button>
            </td>
            <td v-if="accomodation.reclaimed" style="text-align:right;">
              Reserverad
            </td>
          </tr>
          <tr v-for="(school, index) in skischools">
            <td>
              <b>{{school.name}}</b>
              <br>
              {{ school.date | date('D MMMM') }}
            </td>
            <td style="text-align:right;">
              <b>{{(school.quantity * school.price) | currency}}</b>
            </td>
            <td v-if="!school.reclaimed" style="text-align:right;">
              <button class="small" @click="reclaim('skischool', school, index)">Reservera</button>
            </td>
            <td v-if="school.reclaimed" style="text-align:right;">
              Reserverad
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!params.forceSyncAll">
        <button v-if="params.continueToPayment && canContinue" class="small" @click="closeModal();params.continueToPayment()">Fortsätt till betalning</button>
        <button class="small white border" @click="closeModal()">Stäng</button>
      </div>
      <div v-if="params.forceSyncAll">
        <button :class="{small: true, border: true, disabled: !canContinueAll}" @click="closeModal()">Fortsätt betalningen</button>
        <button class="small white border" @click="cancel()" v-if="!canContinueAll">Avbryt betalning</button>
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapMutations } from 'vuex';
import Modal from '@/components/components/Modal';
import Loading from '@/components/components/Loading';
import API from '@/classes/API';
import moment from 'moment';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
    Loading,
  },
  data() {
    return {
      accomodations: [],
      skischools: [],
      canContinue: false,
      canContinueAll: false,
      loading: true,
    };
  },
  async mounted() {
    const cart = Object.assign({}, this.$store.state.cart);
    this.accomodations = cart.accomodations.filter(a => a.confirmed).map((a) => {
      a.reclaimed = false; // eslint-disable-line
      return a;
    });
    this.skischools = cart.skischools.filter(a => a.confirmed).map((a) => {
      a.reclaimed = false; // eslint-disable-line
      return a;
    });
    this.rentals = cart.rentals.filter(a => a.confirmed).map((a) => {
      a.reclaimed = false; // eslint-disable-line
      return a;
    });
    this.skipasses = cart.skipasses.filter(a => a.confirmed).map((a) => {
      a.reclaimed = false; // eslint-disable-line
      return a;
    });

    // Auto reclaim
    if (this.accomodations.length + this.skischools.length === 0) {
      await this.reclaim('general');
    }

    if (this.accomodations.length + this.skischools.length
      + this.rentals.length + this.skipasses.length === 0) {
      this.$store.state.lockingBeforeTime = null;
      this.$store.state.lockingActive = false;
      this.closeModal();
      setTimeout(this.params.continueToPayment, 1);
    }

    this.loading = false;
  },
  methods: {
    ...mapMutations([
      'openModal',
      'closeModal',
      'closeAllModals',
      'saveCartLocking',
    ]),
    async reclaim(type, unit, index) {
      this.loading = true;

      const $this = this;
      let url = '';
      if (type === 'accomodation') {
        url = `/units/${unit.poolLid}/${unit.unitLid}/reserve/${unit.period.date_arrival}/${unit.period.date_departure}`;
      } else if (type === 'skischool') {
        url = `/skischool/reserve/${unit.activity_lid}/${unit.quantity}`;
      } else {
        url = '/locks/reserve';
      }

      if (this.$store.state.lockingCode) {
        url = `${url}/${this.$store.state.lockingCode}`;
      }

      const orderId = this.$route.query.order || '';
      const orderCode = this.$route.query.code || '';

      url = `${url}?order=${orderId}&code=${orderCode}`;

      const { success, code, before_time, reason } = await API.get(url);

      if (!success) {
        this.openModal(['GeneralModal', {
          title: 'Bokningstillgänglighet',
          content: `<p>${reason}</p>`,
          buttons: [
            {
              title: 'Okej',
              class: '',
              click: () => {
                $this.closeModal();
              },
            },
          ],
        }]);
        return false;
      }

      this.saveCartLocking({
        code,
        beforeTime: before_time, // eslint-disable-line
      });

      if (type === 'accomodation') {
        this.accomodations[index].reclaimed = true; // eslint-disable-line
      } else if (type === 'skischool') {
        this.skischools[index].reclaimed = true; // eslint-disable-line
      }

      this.canContinue = true;

      const reclaimedLength = this.accomodations.filter(a => a.reclaimed === true)
        + this.skischools.filter(a => a.reclaimed === true);

      const totalLength = this.accomodations.filter((a) => {
        console.log(a);
        return true;
      }) + this.skischools.filter((a) => {
        console.log(a);
        return true;
      });

      this.canContinueAll = reclaimedLength.length === totalLength.length; // eslint-disable-line

      this.loading = false;

      return true;
    },
    moment(date, format) {
      const string = moment(date).format(format);
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    closeModalLocal() {
      if (this.params.forceSyncAll) {
        return false;
      }

      this.closeModal();
      return true;
    },
    cancel() {
      this.loading = true;
      this.$root.$emit('cancel-payment', true);
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.disabled
  disabled()

h1
  united-heavy()
  color: #262626;
  text-align: center;
  font-size: 22px;
  font-weight: 900;
  margin-bottom 15px
p
  font-size: 14px;
  font-weight: 300;
  line-height: 1.49;

table
  width 100%
  td
    text-align: left
    padding 10px 15px 10px 0
    vertical-align: top
</style>



// WEBPACK FOOTER //
// ReclaimReservationsModal.vue?27bced37